import script from "./BatchCiManager.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchCiManager.vue?vue&type=script&setup=true&lang=js"

import "./BatchCiManager.vue?vue&type=style&index=0&id=3fc1b830&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc1b830"]])

export default __exports__